import { layer } from "@effect/opentelemetry/WebSdk"
import type * as OtelApi from "@opentelemetry/api"
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http"
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-web"

interface Resource {
  readonly serviceName: string
  readonly serviceVersion?: string
  readonly attributes?: OtelApi.Attributes
}

export const WebSdkLive = (resource: Resource) =>
  layer(() => ({
    resource,
    spanProcessor: [
      new BatchSpanProcessor(
        new OTLPTraceExporter({
          headers: {},
          url: window.location.origin + "/api/traces"
        })
      )
    ]
  }))

/**
 * @param dataset optional Honeycomb dataset. When set, adds the
 *   `x-honeycomb-dataset` header (frontend passes "configurator-traces";
 *   backend omits it → header absent, preserving prior behavior).
 */
export const SentrySdkLive = (resource: Resource, env: string, dataset?: string) =>
  layer(() => ({
    resource,
    spanProcessor: [
      new BatchSpanProcessor(
        new OTLPTraceExporter({
          headers: {
            "x-honeycomb-team": env === "prod"
              ? "hcbik_01ks4y4gyemnhqwncv11g5vw5j3ge4cbqw7t4zbkascxwxqn8gxz34pg56"
              : "hcbik_01ks4y3pd13msksbnnj7zdcs0maq24jcmsnaj6e54mwq765cx3vhkm6nz7",
            ...(dataset ? { "x-honeycomb-dataset": dataset } : {})
          },
          url: "https://api.eu1.honeycomb.io/v1/traces"
        })
      )
    ]
  }))
